

export default{

  methods: {

    articleContentFunc(content){

      let encodedImages = content.querySelectorAll('.encoded-image');

      encodedImages.forEach(cvs => {
        var ctx= cvs.getContext('2d');
        var width = cvs.getAttribute('width'),
            height = cvs.getAttribute('height')
        var img = new Image();
        img.src = 'data:'+cvs.getAttribute('type')+';base64,'+cvs.getAttribute('data');
        img.onload = function(){
          ctx.drawImage(img, 0, 0, width, height);
          cvs.removeAttribute('data')
        }
      });
      
    }
  }
}